$(document).ready(function () {
  $('input[name="address[zip_code]"], [data-mask-cep]').mask('00000-000');
  $('input[name="cnpj"], [data-mask-cnpj], .cnpj-mask').mask('00.000.000/0000-00');
  $('input[name="cpf"], [data-mask-cpf], .cpf-mask').mask('000.000.000-00');
  $('input[name="phone"], [data-mask-phone]').mask('(00) 0000-0000');
  $('input[name="cellphone"], [data-mask-cellphone]').mask('(00) 00000-0000');
  $('input[name="initial_date"]').mask('00/00/0000');
  $('input[name="final_date"]').mask('00/00/0000');
  $('.installer').mask('Z', {translation: {'Z': {pattern: /[a-zA-Z0-9.\-_]/, recursive: true}}});
  $('.installer-size').mask('Z', {translation: {'Z': {pattern: /[0-9,]/, recursive: true}}});
  $('.maskMachineId').mask('AAAAAAAAAA');
  $('.only-numbers').mask('0#');
  $('.quantity-product').mask('0000000');
  $('input[name="rg"], [data-mask-rg]').mask("99.999.999-9");
  $('input[name="date_of_birth"]').mask("99/99/9999");
  $('input[name="price"], .money-mask').mask('###.##0,00', {reverse: true});
  $('.maskMoney').maskMoney({thousands: '.', decimal: ','});
  $('input[name="expires"], .date-mask').mask('00/00/0000');
  $('input[name="dpi"], [data-mask-dpi]').mask('000 dpi', {placeholder: '___ dpi', reverse: true});
  $('.coupon').mask('AAAAAAAAAAAAAAA');
  $('.phone-mask').mask(nineDigitsBehavior, nineDigitsOptions);
  $('input[name="ie"]').mask('#');
});
const nineDigitsBehavior = function (val) {
  if (val.replace(/\D/g, '').length === 11) {
    return '(00) 00000-0000';
  }

  return '(00) 0000-00000';
};

const nineDigitsOptions = {
  onKeyPress: function (val, e, field, options) {
    field.mask(nineDigitsBehavior.apply({}, arguments), options);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/masks/masks.js